<template>
  <nav class="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
    <div class="max-w-7xl mx-auto px-4 py-3">
      <div class="flex items-center justify-between">
        <!-- 左侧 Logo 和地域选择 -->
        <div class="flex items-center space-x-6">
          <div
            class="text-gray-600 hover:text-primary transition-colors text-sm"
            height="50px"
          >
            <img
              src="https://www.huizhaowo.com/assets/img/logo.png"
              alt="logo"
              width="100px"
              height="auto"
            />
          </div>
          <div class="text-sm pl-12">
            <i class="ri-map-pin-line text-sm"></i>北京
          </div>
        </div>
        <!-- 中间导航菜单 -->
        <div class="flex items-center space-x-6">
          <router-link
            to="/"
            class="text-gray-900 hover:text-primary transition-colors text-sm"
            >首页</router-link
          >
          <router-link
            to="/rent"
            class="text-gray-600 hover:text-primary transition-colors text-sm"
            >租赁中心</router-link
          >
          <router-link
            to="/caseshare"
            class="text-gray-600 hover:text-primary transition-colors text-sm"
            >案例分享</router-link
          >
          <router-link
            to="/quickorder"
            class="text-gray-600 hover:text-primary transition-colors text-sm"
            >快速预订</router-link
          >
          <router-link
            to="/join"
            class="text-gray-600 hover:text-primary transition-colors text-sm"
            >供应商加盟</router-link
          >
          <router-link
            to="/article"
            class="text-gray-600 hover:text-primary transition-colors text-sm"
            >资讯中心</router-link
          >
          <router-link
            to="/about"
            class="text-gray-600 hover:text-primary transition-colors text-sm"
            >关于我们</router-link
          >
        </div>
        <!-- 右侧功能区 -->
        <div class="flex items-center space-x-6">
          <!-- 购物车  链接是/cart-->
          <div class="relative">
            <router-link
              to="/cart"
              class="w-6 h-6 flex items-center justify-center"
            >
              <i class="ri-shopping-cart-line text-lg text-gray-600"></i>
            </router-link>
            <span
              class="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center"
              >{{ cart_count }}</span
            >
          </div>

          <!-- 电话 -->
          <div class="flex items-center space-x-2">
            <div class="w-4 h-4 flex items-center justify-center">
              <i class="ri-phone-line text-primary"></i>
            </div>
            <span class="text-primary font-medium">010-84855667</span>
          </div>
          <!-- 登录注册 -->
          <div class="flex items-center space-x-3">
            <template v-if="!isLoggedIn">
              <button
                class="bg-primary text-white px-4 py-2 !rounded-button hover:bg-secondary transition-colors whitespace-nowrap"
                @click="goToLogin"
              >
                登录注册
              </button>
            </template>
            <template v-else>
              <div
                class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center cursor-pointer"
                @click="goToUcenter"
              >
                <img
                  :src="avatar"
                  alt="用户头像"
                  class="w-full h-full rounded-full"
                />
              </div>
              <span class="text-gray-900 cursor-pointer" @click="goToUcenter">{{
                username
              }}</span>
              <button
                class="text-gray-600 hover:text-primary transition-colors"
                @click="logout"
              >
                退出
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import api from "@/utils/api.js";

export default {
  name: "Nav",
  data() {
    return {
      isLoggedIn: false,
      username: "",
      avatar: "",
    };
  },
  computed: {
    // 获取购物车商品数量
    cart_count() {
      try {
        const userInfo = localStorage.getItem("userInfo");
        if (userInfo) {
          const user = JSON.parse(userInfo);
          return user.cart_count || 0;
        }
        return 0;
      } catch (error) {
        console.error("获取购物车数量失败:", error);
        return 0;
      }
    },
  },
  mounted() {
    this.checkLoginStatus();
  },
  methods: {
    // 检查登录状态
    async checkLoginStatus() {
      // 首先检查localStorage中的用户信息
      const userInfo = localStorage.getItem("userInfo");
      const token = localStorage.getItem("token");

      if (userInfo && token) {
        try {
          const user = JSON.parse(userInfo);
          this.isLoggedIn = true;
          this.username = user.nickname || user.username || "用户";
          this.avatar = user.avatar || "";
        } catch (e) {
          console.error("解析用户信息失败:", e);
          this.logout();
        }
      } else {
        this.isLoggedIn = false;
        this.username = "";
      }
    },

    goToLogin() {
      this.$router.push("/login");
    },
    // 去用户中心
    goToUcenter() {
      this.$router.push("/ucenter/index");
    },
    goToRegister() {
      this.$router.push("/register");
    },

    async logout() {
      try {
        // 调用API进行登出,使用store清除用户信息
        const result = await this.$store.dispatch("user/logout");
        if (result) {
          this.isLoggedIn = false;
          this.username = "";
          this.avatar = "";
        }
      } catch (error) {
      } finally {
        // 可选：登出后跳转到登录页
        this.$router.push("/index");
      }
    },
  },
};
</script>

<style scoped>
/* 导航栏样式 */
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue